import { bindRequestLogic } from './utils'
import Types from '../actionTypes/firmwareCategory'
import { firmwareCategoryAPI } from '../api'

const getSystemFirmwareCategories = bindRequestLogic({
  clientFunc: firmwareCategoryAPI.getSystemFirmwareCategories,
  type: Types.GET_SYSTEM_FIRMWARE_CATEGORIES_REQUEST,
  successType: Types.GET_SYSTEM_FIRMWARE_CATEGORIES_SUCCESS,
  failType: Types.GET_SYSTEM_FIRMWARE_CATEGORIES_FAILED,
  isQueryParam: true
})

export default [getSystemFirmwareCategories]
